/**
 * `Object.hasOwn` есть в Chromium с 93-й версии. Его вызывают htmlparser2 12 и соседние пакеты,
 * которые приходят с `sanitize-html` 2.17.6+: без полифила SEO-блок листинга падает при отрисовке,
 * и корневой перехватчик ошибок заменяет всю страницу пустым элементом.
 */

// В tsconfig сервиса нет lib es2022, поэтому тип `Object.hasOwn` описан здесь
interface IObjectWithHasOwn {
  hasOwn?: (object: object, key: PropertyKey) => boolean;
}

if (!(Object as IObjectWithHasOwn).hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    // На null и undefined бросает TypeError, как встроенный
    value: (object: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(object, key),
    configurable: true,
    writable: true,
  });
}

export {};
